// Sub‑reducer for the `implantationScheduleStep` slice of the pad‑initialization feature.
// Stores implantation visit events (normalized) and a reference to the padVisit.
import { USER_TYPE } from 'app/config/users';
import { VISITATION_TYPE_TEMPLATE } from 'app/config/visitationTypeTemplate';
import * as types from 'app/redux/features/pad-initialization/actions/padInitialization.types';
import { getAsyncActionTypeFulfiled } from 'app/redux/features/pad-initialization/actions/padInitialization.types';
import STATUS from '../../constants/status.constant';

const initialState = () => ({
  events: {
    ids: [],
    byEventId: {}
  },
  padVisitId: null,
  padVisit: null,
  status: STATUS.IDLE,
  error: null
});

/**
 * Normalizes an array of event objects into a map keyed by event id.
 */
const normalizeEvents = eventsArray => {
  const byEventId = {};
  eventsArray.forEach(event => {
    if (event.id) {
      byEventId[event.id] = { ...event };
    } else if (event.uniqueId) {
      // Alternative key if id not present
      byEventId[event.uniqueId] = { ...event };
    }
  });

  return {
    ids: Object.keys(byEventId),
    byEventId
  };
};

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case types.ACTION_TYPES.SELECT_AND_UPDATE_DATA: {
      const { ImplantationVisit } = action.payload || {};
      if (ImplantationVisit) {
        const { events = [], padVisit } = ImplantationVisit;
        const normalizedEvents = normalizeEvents(Array.isArray(events) ? events : []);
        return {
          events: normalizedEvents,
          padVisitId: padVisit && padVisit.id ? padVisit.id : null,
          status: STATUS.IDLE,
          error: null
        };
      }
      return state;
    }
    case getAsyncActionTypeFulfiled(types.ACTION_TYPES.FETCH_PAD_DATA): {
      const pad = action.payload;
      const padVisits = pad.padVisits || [];
      // Find the implantation visit for client (HOMECARE)
      const implantationVisit = padVisits.find(v => {
        const { responsibleType, visitationType, padVisitType } = v;
        const isSuspension = padVisitType === 'SUSPENSION';
        const isClient = responsibleType === USER_TYPE.HOMECARE;
        const templateId =
          visitationType &&
          visitationType.visitationTypeTemplate &&
          visitationType.visitationTypeTemplate.id;
        const isImplantation = templateId === VISITATION_TYPE_TEMPLATE.IMPLANTATION;
        return !isSuspension && isClient && isImplantation;
      });
      if (implantationVisit) {
        return {
          events: { ids: [], byEventId: {} },
          padVisitId: implantationVisit.id || null,
          status: STATUS.IDLE,
          error: null
        };
      }
      return state;
    }
    case getAsyncActionTypeFulfiled(types.ACTION_TYPES.FETCH_PAD_VISIT_DATA): {
      // Cooperative flow does not set implantation; keep current state.
      return state;
    }
    case types.ACTION_TYPES.RESET: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
